'use client';

import { createStore } from 'zustand';

import { PatientOption, ScheduleAgeRange } from '@/types/patient-selection.types';

export interface PatientSelectionRequest {
  ageRange: ScheduleAgeRange;
  onSelectPatient?: (patient: PatientOption) => void;
}

export type PatientSelectionState = {
  isOpen: boolean;
  request: PatientSelectionRequest | null;
};

const initialState: PatientSelectionState = {
  isOpen: false,
  request: null,
};

export const patientSelectionStore = createStore<PatientSelectionState>(() => ({ ...initialState }));

export const openPatientSelection = (request: PatientSelectionRequest) => {
  patientSelectionStore.setState({ isOpen: true, request });
};

export const closePatientSelection = () => {
  patientSelectionStore.setState({ ...initialState });
};

export const selectPatient = (patient: PatientOption) => {
  const { request } = patientSelectionStore.getState();

  closePatientSelection();
  request?.onSelectPatient?.(patient);
};
